export const STATUS_REVIEW = "Review";
export const STATUS_APPROVED = "Approved";
export const STATUS_REJECTED = "Rejected";

export const ALL_STATUSES = [STATUS_REJECTED, STATUS_REVIEW, STATUS_APPROVED];
